import React, { useEffect, useRef, useState } from "react";

import styles from "../../styles/AccountModals.module.css";
import { BASE_URL } from "../../utils/constants";
import axios from "axios";
import toast from "react-hot-toast";
import Spinner from "../../components/spinner";
import { handleApiError } from "../../utils/handleApiError";
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogFooter,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog";
import Button from "../../components/button-v1";
import { Checkbox } from "../../components/ui/checkbox";
const AddAccountModal = ({
  isOpen,
  onClose,
  comp_renderer,
  current_render,
}) => {
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    postal_code: "",
    timezone: "",
    active: true,
  });

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  const handleCheckBoxChange = (name, checked) => {
    // const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const addLocationinfo = async () => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const url = `${BASE_URL}/accounts/${account_id}/new-location/`;

    try {
      setLoading(true);
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLoading(false);
      comp_renderer(!current_render);
      onClose();
      toast.success("Location added successfully");
    } catch (error) {
      handleApiError(error);
      setLoading(false);
    }
  };

  const validateForm = () => {
    let errors = [];

    if (!formData.name.trim()) errors.push("Name is required.");
    if (!formData.timezone.trim()) errors.push("Timezone is required.");
    if (!formData.postal_code.trim()) errors.push("Postal Code is required.");

    if (errors.length > 0) {
      toast.error(errors.join("\n"), {
        autoClose: 5000,
        style: {
          whiteSpace: "pre-line",
          textAlign: "left",
        },
      });
      return false;
    }

    return true;
  };

  const fetchLocationList = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");
      const url = `${BASE_URL}/accounts/${account_id}/locations/?status=active`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      sessionStorage.setItem("loc_list", JSON.stringify(response.data.locations));
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      await addLocationinfo();
      await fetchLocationList();
    }
  };

  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  const timeZones = [
    { label: "Pacific Time (US & Canada)", value: "America/Los_Angeles" },
    { label: "Mountain Time (US & Canada)", value: "America/Denver" },
    { label: "Central Time (US & Canada)", value: "America/Chicago" },
    { label: "Eastern Time (US & Canada)", value: "America/New_York" },
    { label: "UTC", value: "UTC" },
  ];

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Location</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <form
            className={`${styles.comp_wrapper} ${
              loading ? styles.loading : ""
            }`}
          >
            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Location Name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>TimeZone</label>
                <select
                  name="timezone"
                  value={formData.timezone}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Timezone
                  </option>
                  {timeZones.map((timezone, index) => (
                    <option key={index} value={timezone.value}>
                      {timezone.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>Address Line 1</label>
                <input
                  type="text"
                  name="address_line_1"
                  placeholder="Address Line 1"
                  value={formData.address_line_1}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>Address Line 2</label>
                <input
                  type="text"
                  name="address_line_2"
                  placeholder="Address Line 2"
                  value={formData.address_line_2}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>city</label>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={formData.city}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>State</label>
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select a state
                  </option>
                  {states.map((state, index) => (
                    <option key={index} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className={`${styles.input_group} ${styles.postal_code}`}>
              <div className={styles.input_field}>
                <label>Postal Code</label>
                <input
                  type="number"
                  name="postal_code"
                  placeholder="Postal Code"
                  value={formData.postal_code}
                  onChange={handleChange}
                  className="no-arrows"
                />
              </div>
            </div>

            <div
              className={`${styles.input_group} ${styles.checkbox_container}`}
            >
              <div className={styles.input_field}>
                <label className={styles.checkbox_wrapper}>
                  <Checkbox
                    name="active"
                    checked={formData.active}
                    onCheckedChange={(checked) =>
                      handleCheckBoxChange("active", checked)
                    }
                  />
                  Active
                </label>
              </div>
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Add
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddAccountModal;
